import React from "react";

/**
 * Minimal safe markdown renderer for chat messages.
 * Supports: **bold**, *italic*, `code`, and line breaks.
 * Escapes HTML first so LLM output can't inject anything.
 */
const escapeHtml = (str) => (str || "")
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;");

const parseMarkdown = (text) => {
  if (!text) return "";
  let html = escapeHtml(text);
  // Bold: **text**
  html = html.replace(/\*\*([^*\n]+?)\*\*/g, "<strong>$1</strong>");
  // Italic: *text* (avoid double-star matches by requiring not-*)
  html = html.replace(/(^|[^*])\*([^*\n]+?)\*(?!\*)/g, "$1<em>$2</em>");
  // Inline code: `code`
  html = html.replace(/`([^`\n]+?)`/g, '<code class="bg-white/5 px-1 py-0.5 rounded text-[#D4AF37]">$1</code>');
  // Bullets: lines starting with - or • become list items (simple)
  html = html.replace(/(^|\n)[-•]\s+([^\n]+)/g, "$1• $2");
  // Line breaks
  html = html.replace(/\n/g, "<br/>");
  return html;
};

const ChatMarkdown = ({ text, className = "" }) => (
  <span
    className={className}
    dangerouslySetInnerHTML={{ __html: parseMarkdown(text) }}
  />
);

export default ChatMarkdown;
